import * as React from 'react';
import { AddButton } from '@component/index';
import { BackwardOutlined, CaretDownOutlined, DownOutlined } from '@ant-design/icons';
import { Card, Space } from 'antd';
import '@style/component/body-group.less';
import { attributeFields } from '@request/fragments';
import { CardProps } from 'antd/lib/card';

const noneBodyStyle = {
  paddingTop: '10px',
  paddingBottom: '10px'
};

const borderTopStyle = {
  borderTop: '1px solid rgba(0,0,0,0.06)'
};

const borderTopBodyStyle: any = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end'
};

export interface BodyGroupPropsInfo extends CardProps {
  title: string | React.ReactNode;
  extra?: React.ReactNode;
  formGroup?: boolean;
  style?: object;
  onRef?: (ref: BodyGroup) => void;
  extraClick?: () => void;
  bordered?: boolean;
  className?: string;
  disableExtra?: boolean;
  foldable?: boolean;
  defaultFolded?: boolean;
  titleExtra?: React.ReactNode;
  borderTop?: boolean;
  noPadding?: boolean;
  noContent?: boolean;
  noTitleLine?: boolean;
}

export interface BodyGroupStateInfo {
  folded: boolean;
}

export class BodyGroup extends React.Component<
  BodyGroupPropsInfo,
  BodyGroupStateInfo
> {
  public state: BodyGroupStateInfo = {
    folded: this.props.defaultFolded || false
  };

  public open() {
    this.setState({ folded: false });
  }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }
  componentDidUpdate(prevProps: Readonly<BodyGroupPropsInfo>, prevState: Readonly<BodyGroupStateInfo>, snapshot?: any): void {
    if (prevProps.foldable !== this.props.foldable && this.props.foldable) {
      this.setState({ folded: false });
    }
  }

  render() {
    const {
      children,
      title,
      style = {},
      bordered = false,
      className = '',
      disableExtra = false,
      // tslint:disable-next-line
      extraClick = () => {
        // console.log('请添加 extraClick');
      },
      foldable,
      titleExtra,
      borderTop = false,
      noPadding,
      noTitleLine,
      formGroup,
      noContent
    } = this.props;

    const { folded } = this.state;

    let { extra } = this.props;

    extra = disableExtra ? (
      ''
    ) : extra ? (
      extra
    ) : '';

    return (
      <Card
        title={
          titleExtra ? (
            <div className="title-container">

              <div
                className="group-title"
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  if (!foldable) {
                    return;
                  }
                  this.setState({ folded: !folded });
                }}
              >
                {' '}
                {title}
              </div>
              {titleExtra}
              {foldable && (
                <DownOutlined
                  style={{ marginLeft: 16 }}
                  className={`arrow-${folded ? 'down' : 'up'}`}
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    if (!foldable) {
                      return;
                    }
                    this.setState({ folded: !folded });
                  }} />
              )}
            </div>
          ) : (
            <>{title}{foldable && (
              <DownOutlined
                style={{ marginLeft: 16 }}
                className={`arrow-${folded ? 'down' : 'up'}`}
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                  if (!foldable) {
                    return;
                  }
                  this.setState({ folded: !folded });
                }} />
            )}</>

          )
        }
        className={`body-group ${className} ${noPadding ? 'no-padding' : ''} ${(noTitleLine) ? 'no-title-line' : ''} ${(formGroup && !folded) ? 'with-wrapper' : ''} ${(noContent || folded) ? 'no-content' : ''}`}
        style={{
          ...style,
          ...(borderTop ? borderTopStyle : {})
        }}
        bordered={bordered}
        extra={(!foldable || !folded) && <Space>{extra}</Space> || ''}
        bodyStyle={
          foldable && folded
            ? noneBodyStyle
            : borderTop
              ? borderTopBodyStyle
              : undefined
        }
      >
        {
          // foldable && folded ? '' : children &&
          children}
      </Card>
    );
  }
}
